import { createChildListModalContainer } from 'factories/ChildListModal'
import actions from 'actions/lists/listItems'
import Component from 'components/Lists/FormView/FileItems'

export default createChildListModalContainer({ actions })(Component)
